import type { TransitionMeetingManageResourceTeacherScoresItem } from "api/generated";
import type { TeacherScore } from "meetings/advisory/types";

export const teacherScoreFromDto = (
  dto: TransitionMeetingManageResourceTeacherScoresItem,
): TeacherScore => ({
  teacherShortage: dto.teacher_shortage,
  total: dto.total,
  filled: dto.filled,
  percentage: dto.total > 0 ? Math.round((dto.filled / dto.total) * 100) : 0,
});
